import { Story } from '../../DocTypes';

export const selectableWithDefaultStory: Story = {
  title: 'Selectable with default',
  description: 'List with selectable items with Deli Alli selected by default',
  coreComponent: {
    html: `<tag-list primary-field='name' selectable></tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Harry Maguire' },
      { name: 'Luke Shaw' },
      { name: 'Mason Mount' },
      { name: 'Dele Alli' },
    ]);
    tagList.select({ name: 'Dele Alli' }, true);
  });
    `,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedItem, setSelectedItem] = React.useState({ name: 'Dele Alli' })
    return (
      <div>
        <TagList
          primaryField='name'
          selectable
          data={[
            { name: 'Harry Maguire' },
            { name: 'Luke Shaw' },
            { name: 'Mason Mount' },
            { name: 'Dele Alli' },
          ]}
          selectedItem={selectedItem}
          onListItemSelected={e => setSelectedItem(e.detail.item)}
        />

        <p>{selectedItem.name} is selected</p>
      </div>
    )
  }`,
  },
};
